<ng-template
    let-overlay="overlay"
    let-dates="dates"
    #tpl
>
    <ng-container *ngFor="let date of dates">
        <div class="list">
            <div class="dateTitle">
                <span>
                    {{ date.start | cmpsDate: 'MM-dd-y' }}
                    <ng-container
                        *ngIf="
                            localState?.dateRange?.periodType !==
                            _PeriodType.DAY
                        "
                    >
                        &nbsp;-&nbsp;
                        {{
                            (date.end > localState?.dateRange?.endDate
                                ? localState.dateRange.endDate
                                : date.end
                            ) | cmpsDate: 'MM-dd-y'
                        }}
                    </ng-container>
                </span>
            </div>
            <ng-container *ngFor="let item of date.items">
                <div
                    class="hover:cmps-cdk-color-blue-100 hover:cmps-cdk-pseudo-child quickSwitchListItem"
                    role="button"
                    tabIndex="-1"
                    (click)="overlay?.toggle(); _onSelectionChange(item)"
                >
                    <div
                        class="hover:cmps-cdk-border-b-color-blue-100 displayName"
                        [class.cmps-cdk-border-b-color-blue-100]="
                            selected?.initialCriteria === item.initialCriteria
                        "
                    >
                        <cmps-icon
                            class="hover:cmps-cdk-fill-blue-100 cmps-cdk-mr-0dot5"
                            [class.cmps-cdk-fill-blue-100]="
                                selected?.initialCriteria ===
                                item.initialCriteria
                            "
                            [class.cmps-cdk-fill-grey-400]="
                                selected?.initialCriteria !==
                                item.initialCriteria
                            "
                            [svgIcon]="
                                item.extra.teamSuperGroup !== true
                                    ? 'account'
                                    : 'account-multiple'
                            "
                        ></cmps-icon>
                        <span>{{ item.shortName }}</span>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<div *ngIf="_superGroupItemList?.length > 0">
    <span class="quickSwitchListTitle">
        {{
            state?.quickSwitch?.title != null
                ? state.quickSwitch.title
                : (_i18n._147_SUPERGROUPS | translate)
        }}
    </span>
    <div class="d-inline-flex flex-wrap">
        <ng-container *ngFor="let item of _superGroupItemList; let i = index">
            <div
                class="mb-1 hover:cmps-cdk-color-blue-100 hover:cmps-cdk-pseudo-child quickSwitchListItem"
                role="button"
                tabIndex="-1"
                (click)="_onSelectionChange(item)"
            >
                <div
                    class="hover:cmps-cdk-border-b-color-blue-100 displayName"
                    [class.cmps-cdk-border-b-color-blue-100]="
                        selected?.initialCriteria === item.initialCriteria
                    "
                >
                    <cmps-icon
                        class="hover:cmps-cdk-fill-blue-100 cmps-cdk-mr-0dot5"
                        [class.cmps-cdk-fill-blue-100]="
                            selected?.initialCriteria === item.initialCriteria
                        "
                        [class.cmps-cdk-fill-grey-400]="
                            selected?.initialCriteria !== item.initialCriteria
                        "
                        [svgIcon]="
                            item.extra.teamSuperGroup !== true
                                ? 'account'
                                : 'account-multiple'
                        "
                    ></cmps-icon>
                    <span>{{ item.shortName }}</span>
                </div>
                <ng-container *ngIf="i === 0">
                    <div class="dateRanges">
                        <ng-container *ngFor="let d of item.dateRanges">
                            <span>
                                {{ d.start | cmpsDate: 'MM-dd-y' }}
                                <ng-container
                                    *ngIf="
                                        localState?.dateRange?.periodType !==
                                        _PeriodType.DAY
                                    "
                                >
                                    &nbsp;-&nbsp;
                                    {{
                                        (d.end > localState?.dateRange?.endDate
                                            ? localState.dateRange.endDate
                                            : d.end
                                        ) | cmpsDate: 'MM-dd-y'
                                    }}
                                </ng-container>
                            </span>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <ng-container *ngIf="_previousSuperGroupList?.length > 0">
            <button
                class="btn bg-transparent cmps-cdk-color-blue-100 quickSwitchListButton"
                tabIndex="-1"
                [cmpsOverlayTrigger]="filterTpl"
                placement="right-center"
            >
                <span>
                    {{
                        state?.quickSwitch?.buttonName != null
                            ? state.quickSwitch.buttonName
                            : (_i18n._7131_PREVIOUS_SUPERGROUPS | translate)
                    }}
                </span>
                <cmps-icon
                    class="cmps-cdk-ml-0dot5"
                    svgIcon="plus-circle-outline"
                ></cmps-icon>
            </button>
            <ng-template
                let-overlay="overlay"
                #filterTpl
            >
                <div
                    class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 insight-pop-up-frame insight-super-group"
                >
                    <div class="d-flex align-items-center">
                        <div class="col flex-grow-1 cmps-cdk-font-bold">
                            {{ _i18n._834_SELECT_A_SUPERGROUP | translate }}
                        </div>
                        <button
                            class="btn bg-transparent"
                            tabIndex="-1"
                            (click)="overlay?.toggle()"
                        >
                            <cmps-icon
                                class="cmps-cdk-fill-grey-300 hover:cmps-cdk-fill-grey-400"
                                svgIcon="close"
                            ></cmps-icon>
                        </button>
                    </div>

                    <div class="insight-super-group insight-pop-up-content">
                        <div class="col">
                            <div class="row mb-2">
                                <div class="col-6">
                                    <div class="typeTitle">Personal</div>
                                </div>
                                <div class="col-6">
                                    <div class="typeTitle">Subordinates</div>
                                </div>
                            </div>
                            <div class="row insight-scrollable">
                                <div class="col-6">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            tpl;
                                            context: {
                                                overlay,
                                                dates: _personalDates
                                            }
                                        "
                                    ></ng-container>
                                </div>
                                <div
                                    class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 insight-separator"
                                ></div>
                                <div class="col-6">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            tpl;
                                            context: {
                                                overlay,
                                                dates: _teamDates
                                            }
                                        "
                                    ></ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ng-container>
    </div>
</div>
